/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebphotospartialdescription4Inputs */

const en_placewebphotospartialdescription4 = /** @type {(inputs: Placewebphotospartialdescription4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can add them later on the place page.`)
};

const de_placewebphotospartialdescription4 = /** @type {(inputs: Placewebphotospartialdescription4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du kannst sie später auf der Seite des Orts ergänzen.`)
};

/**
* | output |
* | --- |
* | "You can add them later on the place page." |
*
* @param {Placewebphotospartialdescription4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebphotospartialdescription4 = /** @type {((inputs?: Placewebphotospartialdescription4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebphotospartialdescription4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebphotospartialdescription4(inputs)
	return de_placewebphotospartialdescription4(inputs)
});
export { placewebphotospartialdescription4 as "placeWebPhotosPartialDescription" }